import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ISlotsIconProps extends ISvgIconProps {

}

export class SlotsIcon extends React.Component<ISlotsIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g transform="translate(-33.763 -638.921)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5">
                    <path strokeLinejoin="round" d="m43.963 651.351.065-1.025"/>
                    <path strokeLinejoin="round" d="m37.639 651.351.065-1.025"/>
                    <path strokeLinejoin="round" d="m50.564 651.351.065-1.025"/>
                    <rect width="18.895" height="11.657" rx="2" transform="translate(34.638 645.093)"/>
                    <path d="M40.972 655.527v-9.212"/>
                    <path d="M47.296 655.527v-9.212"/>
                    <path d="M54.188 650.839h2.7v-4.745"/>
                </g>

                {/* <g fill="currentColor">
                    <path d="M10.66 13.192h-0.038a0.6 0.6 0 0 1 -0.56 -0.64l0.051 -0.818a0.6 0.6 0 0 1 0.64 -0.56 0.6 0.6 0 0 1 0.56 0.64l-0.054 0.816a0.6 0.6 0 0 1 -0.599 0.562Z"/>
                    <path d="M5.602 13.192h-0.038a0.6 0.6 0 0 1 -0.56 -0.64l0.051 -0.818a0.6 0.6 0 0 1 0.64 -0.56 0.6 0.6 0 0 1 0.56 0.64l-0.054 0.816a0.6 0.6 0 0 1 -0.599 0.562Z"/>
                    <path d="M15.941 13.192h-0.038a0.6 0.6 0 0 1 -0.56 -0.64l0.051 -0.818a0.6 0.6 0 0 1 0.64 -0.56 0.6 0.6 0 0 1 0.56 0.64l-0.054 0.816a0.6 0.6 0 0 1 -0.599 0.562Z"/>
                    <path d="M4.8 6.986h11.916a2.202 2.202 0 0 1 2.2 2.2v6.126a2.202 2.202 0 0 1 -2.2 2.2H4.8a2.202 2.202 0 0 1 -2.2 -2.2v-6.126A2.202 2.202 0 0 1 4.8 6.986Zm11.916 9.326a1.001 1.001 0 0 0 1 -1v-6.126a1.001 1.001 0 0 0 -1 -1H4.8a1.001 1.001 0 0 0 -1 1v6.126A1.001 1.001 0 0 0 4.8 16.311Z"/>
                    <path d="M8.267 16.534a0.6 0.6 0 0 1 -0.6 -0.6v-7.37a0.6 0.6 0 0 1 0.6 -0.6 0.6 0.6 0 0 1 0.6 0.6v7.37a0.6 0.6 0 0 1 -0.6 0.6Z"/>
                    <path d="M13.326 16.534a0.6 0.6 0 0 1 -0.6 -0.6v-7.37a0.6 0.6 0 0 1 0.6 -0.6 0.6 0.6 0 0 1 0.6 0.6v7.37a0.6 0.6 0 0 1 -0.6 0.6Z"/>
                    <path d="M21.6 12.78h-2.76a0.6 0.6 0 0 1 0 -1.2h1.56v-3.2a0.6 0.6 0 0 1 1.2 0Z"/>
                </g> */}
            </SvgIcon>
        );
    }
}
